<template>
  <pdl-steps v-model="currentStep" class="mt-2 mb-4" @update:modelValue="navigate">
    <template v-for="link in steps" :key="`${link.progressBarId}-${isTranslationLoaded}`">
      <pdl-steps-item :qaid="`${link.progressBarId}-nav-link`" v-html="$t(`text.${link.progressBarId}`)">
      </pdl-steps-item>
    </template>
  </pdl-steps>
</template>
<script>
import {PdlSteps, PdlStepsItem} from '@pedal/pdl-steps';
import {useIsTranslationLoaded} from '@/composables/is-translation-loaded.js';

export default {
  components: {PdlSteps, PdlStepsItem},

  props: {
    steps: {
      type: Array,
      default: () => [],
      required: true,
    },
    progressBarId: {
      type: String,
      default: '',
      required: false,
    },
  },

  data() {
    return {
      contextPath: ACC.config.encodedContextPath || '',
      isTranslationLoaded: false,
    };
  },

  created() {
    this.currentStep = this.steps.indexOf(this.steps.find((item) => item.progressBarId === this.progressBarId));
    useIsTranslationLoaded(() => {
      this.isTranslationLoaded = true;
    });
  },

  methods: {
    navigate(stepIndex) {
      if (this.steps.length > stepIndex) {
        window.location.href = `${this.contextPath}${this.steps[stepIndex].url}`;
      }
    },
  },
};
</script>
